import { NODE_ENV } from './env';
const ANALYTICS_LOG = Symbol('ANALYTICS_LOG');
if (NODE_ENV === 'test') {
  global[ANALYTICS_LOG] = global[ANALYTICS_LOG] || {
    loaded: false,
    identity: null,
    events: {}
  };
}

// This will be `undefined` unless running with NODE_ENV === "test"
const log = global[ANALYTICS_LOG];
const MockAnalyticsStore = {
  /**
   * Record a call to `load`
   *
   * **Internal use only**
   */
  _recordLoad() {
    if (NODE_ENV === 'test') {
      log.loaded = true;
    }
  },
  /**
   * Record a call to `identify`
   *
   * **Internal use only**
   */
  _recordIdentify(userId, traits) {
    if (NODE_ENV === 'test') {
      log.identity = {
        userId,
        traits: traits || null
      };
    }
  },
  /**
   * Record a call to `track`
   *
   * **Internal use only**
   * @param event event name
   * @param properties event properties
   */
  _recordTrack(event) {
    let properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (NODE_ENV === 'test') {
      const events = log.events[event] || [];
      events.push(properties);
      log.events[event] = events;
    }
  },
  /**
   * Returns the `loaded` state from analytics store
   */
  isLoaded() {
    if (NODE_ENV !== 'test') throw new Error('You cannot use MockAnalyticsStore outside of tests');
    return !!log.loaded;
  },
  /**
   * Returns the `userId` from the last call to `analytics.identify()
   */
  currentUserId() {
    if (NODE_ENV !== 'test') throw new Error('You cannot use MockAnalyticsStore outside of tests');
    return log.identity && log.identity.userId;
  },
  /**
   * Returns the `traits` from the last call to `analytics.identify()`
   */
  currentUserTraits() {
    if (NODE_ENV !== 'test') throw new Error('You cannot use MockAnalyticsStore outside of tests');
    return log.identity && log.identity.traits;
  },
  /**
   * Returns `true` if an event has been recorded
   */
  hasEvent(event) {
    if (NODE_ENV !== 'test') throw new Error('You cannot use MockAnalyticsStore outside of tests');
    return !!log.events[event];
  },
  hasEventWithProperty(event, propertyKey, propertyValue) {
    if (NODE_ENV !== 'test') throw new Error('You cannot use MockAnalyticsStore outside of tests');
    if (!MockAnalyticsStore.hasEvent(event)) return false;
    const events = log.events[event] || [];
    return !!events.find(p => p[propertyKey] === propertyValue);
  },
  hasEventWithProperties(event, properties) {
    if (NODE_ENV !== 'test') throw new Error('You cannot use MockAnalyticsStore outside of tests');
    if (!MockAnalyticsStore.hasEvent(event)) return false;
    const events = log.events[event] || [];
    return !!events.find(p => {
      for (const key of Object.keys(properties)) {
        if (properties[key] !== p[key]) return false;
      }
      return true;
    });
  },
  reset() {
    log.identity = null;
    log.events = {};
    log.loaded = false;
  }
};
export default MockAnalyticsStore;
//# sourceMappingURL=MockAnalyticsStore.js.map